import BigDialog from 'components/BigDialog';
import BaseTable from 'components/Tables/BaseTable';
import { actions as productActions } from 'ducks/products';
import { actions as productRMActions } from 'ducks/productRawMaterials';
import { sortBy } from 'lodash';
import ShipmentInserterTable from 'pages/Products/ProductRM/shipmentInserterTable';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import {
    filterByFunctionSelector, groupBy, mixtureSubstancesByMixture, shipmentsByRawMaterial
} from 'selectors/generic';
import theme from 'source/theme';
import { MIXTURE } from 'utils/constants/coreConstants';
import { UJ } from 'utils/constants/reach_role';
import columns from 'utils/tables/columns/product/productInRawMaterials';
import { currentUser } from 'selectors/currentUser';

const defaultProductRM = (
    product_id,
    raw_material_id,
    raw_material_final = false,
    added_to_charge = true,
    excluded_from_final_product = false,
    contributes_to_hazard = false,
    mixture_id = null,
    mixture_substance_id = null
) => ({
    product_id, raw_material_id, raw_material_final, added_to_charge, excluded_from_final_product,
    contributes_to_hazard, mixture_id, mixture_substance_id
});

const customProductRM = (
    product_id,
    raw_material_id,
    preExistentMP,
    mixture_id = null,
    mixture_substance_id = null
) => ({
    product_id,
    raw_material_id,
    // raw_material_final: preExistentMP.raw_material_final,
    raw_material_final: false,
    // added_to_charge: preExistentMP.added_to_charge,
    added_to_charge: true,
    excluded_from_final_product: preExistentMP.excluded_from_final_product,
    contributes_to_hazard: preExistentMP.contributes_to_hazard,
    mixture_id,
    mixture_substance_id
});

// `product.product_raw_materials`, keyed by product_id.
const compositionByProduct = groupBy('productRawMaterials', 'product_id');

const Component = props => {
    let {
        composition, highlightMP, productId, productsById, rawMaterials,
        rawMaterialsById, shipmentsOf, substancesOfMixture, user
    } = props;
    const {
        createProductRM, fetchProduct, handleCloseDrawer, setHighlightSubstances,
        removeProductRM, setHighlightMP
    } = props;

    const tableRef = useRef(null);

    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedPMps, setselectedPMps] = useState([]);

    const [RMShipmentInsert, setRMShipmentInsert] = useState(null);
    const [posShipmentInsertRequest, setPosShipmentInsertRequest] = useState(null);
    const handleCloseShipmentInserter = () => {
        setLoading(false);
        setPosShipmentInsertRequest(null);
    };

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // TODO take a look at this implementation ... ??? no optimal
        // TODO the conditions ( prm.raw_material_id.code !== '' &&  prm.raw_material_id.code !== null )
        // are to avoid the garbage that might come from API
        const matchProductRM = (composition[productId] || []).filter(prm =>
            prm.raw_material_id && !prm.mixture_id && prm.added_to_charge &&
            rawMaterialsById[prm.raw_material_id].code !== '' &&
            rawMaterialsById[prm.raw_material_id].code !== null
        );

        setselectedPMps(matchProductRM);
        setSelectedIds(matchProductRM.map(prm => prm.raw_material_id));
    }, [productsById]);

    /**
     * return true if no shipment is found for MP as UJ. If any is detected
     * returns false. No need to create new shipment as UJ
     */
    const createShipmentForRM = (rm) => {
        const shipments = shipmentsOf[rm.id] || [];
        if (shipments.length === 0) {
            return true;
        } else {
            const notUJ = shipments.map(s => s.reach_role !== UJ).every(t => t);
            if (notUJ) {
                return true;
            }
        }
        return false;
    };

    rawMaterials = rawMaterials.map(subst => {
        if (selectedIds.includes(subst.id)) {
            const pMp = selectedPMps.find(pMp => pMp.raw_material_id === subst.id);
            return { ...subst, tableData: { checked: true }, product_raw_material_id: pMp.id };
        } else {
            return { ...subst, tableData: { checked: false } };
        }
    });

    const orderedSubstances = sortBy(rawMaterials, [row => !selectedIds.includes(row.id), 'id']);

    const InRawMaterialSelectorTable = () => (
        <BaseTable
            ref={tableRef}
            titleBack={true}
            titleAction={handleCloseDrawer}
            title={`CARGA`}
            columns={columns(user)}
            data={orderedSubstances}
            order={false}
            options={{
                selection: true,
                showTextRowsSelected: false,
                showSelectAllCheckbox: false,
                rowStyle: rowData => ({
                    backgroundColor: highlightMP.includes(rowData.id) && rowData.tableData.checked ?
                        theme.palette.primary.light : ''
                })
            }}
            onRowClick={() => null}
            onRowDoubleClick={rowData => {
                if (rowData.type === MIXTURE) {
                    setHighlightSubstances(
                        (substancesOfMixture[rowData.id] || []).map(substance => substance.substance_id));
                } else {
                    setHighlightSubstances([rowData.id]);
                }
                setHighlightMP([rowData.id]);
            }}
            isLoading={loading}
            onSelectionChange={(rows, difRow) => {
                setLoading(true);
                if (rows.length > selectedIds.length) {

                    const filteredProductRM = (composition[productId] || []).filter(pMP =>
                        rawMaterialsById[pMP.raw_material_id].type !== MIXTURE
                    );

                    // Case you are inserting a SUBSTANCE OR POLIMER
                    if (rawMaterialsById[difRow.id].type !== MIXTURE) {
                        const productRMCreate = () => () =>
                            createProductRM(baseProductRM)
                                .then(() => fetchProduct(productId))
                                .catch(e => alert(e))
                                .finally(() => setLoading(false));

                        let baseProductRM = defaultProductRM(productId, difRow.id);
                        const preExistentMP = filteredProductRM.find(pMP => pMP.raw_material_id === difRow.id);
                        if (preExistentMP) {
                            baseProductRM = customProductRM(productId, difRow.id, preExistentMP);
                        }
                        if (createShipmentForRM(difRow)) {
                            setRMShipmentInsert(difRow);
                            //TODO send CLOSE to SHIPMENT dialog box
                            setPosShipmentInsertRequest(productRMCreate);
                        } else {
                            createProductRM(baseProductRM)
                                .then(() => fetchProduct(productId))
                                .catch(e => alert(e))
                                .finally(() => setLoading(false));
                        }
                        // Case you are inserting a MIXTURE
                    } else {
                        const promiseArray = [() => createProductRM(defaultProductRM(productId, difRow.id))];

                        // const substancesFromMixIds = rawMaterialsById[difRow.id].substances.map(s => s.substance_id);
                        // substancesFromMixIds.forEach(substanceId => {
                        //   const preExistentMP = filteredProductRM.find(pMP => pMP.raw_material_id.id === substanceId)
                        //   if (preExistentMP) {
                        //     promiseArray.push(() => createProductRM(
                        //       customProductRM(productId, substanceId, preExistentMP, difRow.id)
                        //     ));
                        //   }
                        // });

                        const interSubstances = substancesOfMixture[difRow.id] || [];
                        interSubstances.forEach(interSubstances => {
                            const preExistentMP = filteredProductRM.find(pMP =>
                                pMP.raw_material_id === interSubstances.substance_id
                            );
                            if (preExistentMP) {
                                promiseArray.push(() => createProductRM(
                                    customProductRM(
                                        productId, interSubstances.substance_id, preExistentMP,
                                        difRow.id, interSubstances.id
                                    ))
                                );
                            }
                        });

                        const productRMmixCreate = () => () => {
                            return Promise.all(promiseArray.map(promise => promise()))
                                .then(() => fetchProduct(productId))
                                .catch(e => alert(e))
                                .finally(() => setLoading(false));
                        };

                        if (createShipmentForRM(difRow)) {
                            setRMShipmentInsert(difRow);
                            //TODO send CLOSE to SHIPMENT dialog box
                            setPosShipmentInsertRequest(productRMmixCreate);
                        } else {
                            return Promise.all(promiseArray.map(promise => promise()))
                                .then(() => fetchProduct(productId))
                                .catch(e => alert(e))
                                .finally(() => setLoading(false));
                        }
                    }
                } else {
                    const productRMToRemove = (composition[productId] || []).find(pmp =>
                        difRow.product_raw_material_id === pmp.id
                    );
                    removeProductRM(productRMToRemove.id)
                        .then(() => fetchProduct(productId))
                        .catch(e => alert(e))
                        .finally(() => setLoading(false));
                }
            }}
        />
    );

    return (
        <React.Fragment>
            <InRawMaterialSelectorTable/>
            {
                posShipmentInsertRequest &&
                <BigDialog open={true} handleClose={handleCloseShipmentInserter}>
                    <ShipmentInserterTable
                        fullSize={true}
                        rawMaterial={RMShipmentInsert}
                        postInsertRequest={posShipmentInsertRequest}
                        closeParentContainer={handleCloseShipmentInserter}
                        shipmentType={productsById[productId].reach_role}
                    />
                </BigDialog>
            }
        </React.Fragment>

    );
};


const makeMapStateToProps = () => {
    const rawMaterials = filterByFunctionSelector(
        'rawMaterials',
        rm => rm.code !== null && rm.code !== undefined && rm.code !== ''
    );
    const mapStateToProps = (state, props) => ({
        composition: compositionByProduct(state),
        rawMaterials: rawMaterials(state),
        rawMaterialsById: state.rawMaterials.models,
        productsById: state.products.models,
        shipmentsOf: shipmentsByRawMaterial(state),
        substancesOfMixture: mixtureSubstancesByMixture(state),
        user: currentUser(state)
    });
    return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
    fetchProduct: id => dispatch(productActions.fetchOne(id)),
    createProductRM: data => dispatch(productRMActions.createPromise(data)),
    removeProductRM: id => dispatch(productRMActions.removePromise(id))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
